import { Component, inject, signal } from '@angular/core';
import { ButtonComponent } from '../../../../kit/button/button.component';
import { translate } from '../../../../../modules/shared/shared.global-service';
import { ActivatedRoute } from '@angular/router';
import { ReturnButtonComponent } from '../../../../kit/button/return-button.component';
import {
    FolderEPrescriptionsListComponent,
} from '../folder-e-prescriptions-list/folder-e-prescriptions-list.component';
import { FolderEPrescriptionFormComponent } from '../folder-e-prescription-form/folder-e-prescription-form.component';
import {
    FolderEPrescriptionMedicationEntriesModalComponent,
} from '../folder-e-prescription-medication-entries-modal/folder-e-prescription-medication-entries-modal.component';
import { FolderEPrescriptionCreateStore } from './folder-e-prescription-create.store';
import { BaseDialogService } from '../../../../kit/base-dialog/base-dialog-service';
import { FolderEPrescriptionMedicationService } from '../folder-e-prescription-medication.service';
import { EPrescriptionObject } from '@libs/types/src/services/object-type/sukl/e-prescription.object';
import {
    EPrescriptionMedicationRecordObject
} from '@libs/types/src/services/object-type/sukl/e-prescription-medication-record.object';
import { FolderGlobalStore } from '../../../../../store/medicalService/folder.global-store';

@Component({
    selector: 'app-folder-e-prescription-create',
    templateUrl: 'folder-e-prescription-create.component.html',
    styleUrls: ['folder-e-prescription-create.component.scss'],
    providers: [FolderEPrescriptionCreateStore],
    imports: [
        ButtonComponent,
        ReturnButtonComponent,
        FolderEPrescriptionsListComponent,
        FolderEPrescriptionFormComponent,
    ],
})
export class FolderEPrescriptionCreateComponent {
    protected readonly store = inject(FolderEPrescriptionCreateStore);
    protected readonly folderStore = inject(FolderGlobalStore);
    public readonly dialogService = inject(BaseDialogService);
    public readonly route = inject(ActivatedRoute);
    private readonly prescriptionMedicationService = inject(FolderEPrescriptionMedicationService);

    protected prescriptionId = signal<any>(this.route.snapshot.firstChild?.params?.['prescriptionId']);
    protected selectedPrescription = signal<EPrescriptionObject | null>(null);
    public preselectMedication = signal<EPrescriptionMedicationRecordObject | null>(null);
    protected folder = this.folderStore.folder;

    protected openMedicationEntriesModal(_event: Event) {
        const ref = this.dialogService.open(
            FolderEPrescriptionMedicationEntriesModalComponent,
            {
                header: translate.instant('ePrescriptions.medicationEntries.title'),
                styleClass: 'p-dialog-width-80',
            },
        );
        ref.onClose.subscribe((medicationRecord: EPrescriptionMedicationRecordObject) => {
            if (medicationRecord) {
                this.preselectMedication.set(medicationRecord);
            }
        });
    }

    protected async upsertMedication(): Promise<void> {
        const prescription = this.selectedPrescription();
        if (!prescription) return;

        await this.prescriptionMedicationService.upsertMedications(
            prescription, this.folder(), this.store.globalGlobalStore.currentService(),
        );
    }

    protected selection(event: EPrescriptionObject | null): void {
        if (!event || event.id === -1) {
            this.selectedPrescription.set(null);
        } else {
            this.selectedPrescription.set(event);
        }
    }
}
